import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/today` — l'écran « Aujourd'hui », retiré (retours de Chloé, 14/10). L'URL reste pour les
 * favoris : elle mène à l'écran le plus proche, Réseau & Boutiques, qui donne aussi les ventes du
 * jour. Pas de garde ici : c'est celle de Réseau & Boutiques qui décide.
 */
export const Route = createFileRoute('/_authenticated/today')({
  beforeLoad: () => {
    throw redirect({ to: '/network-dashboard', replace: true })
  },
})
